import React from 'react'
import { Checkbox, Divider, Paper, Stack, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import { useGlobalState } from 'state'
import { RoadType } from 'common/types'

type RoadColor = {
  category: string
  color: string
  label: string
}

const roadColors = {
  Jizen: {
    category: '事前',
    color: '#0000FF',
    label: '事前規制'
  },
  Saigai: {
    category: '災害等',
    color: '#FB0006',
    label: '災害規制'
  },
  Kisyou: {
    category: '気象条件',
    color: '#65F2F4',
    label: '気象規制'
  },
  Kouji: {
    category: '工事',
    color: '#E5CF0A',
    label: '工事規制'
  },
  Yokoku: {
    category: '予告',
    color: '#118901',
    label: '予告規制'
  },
  Etc: {
    category: 'その他',
    color: '#8FA8A9',
    label: 'その他規制'
  },
  Event: {
    category: 'イベント',
    color: '#F38336',
    label: 'イベント規制'
  }
}

export const RoadRegulationControl = ({ showControl = true }: { showControl?: boolean }) => {
  const state = useGlobalState()
  const { roadRegulation, setRoadRegulation, roadRegulationTypes, setRoadRegulationTypes } = state.app

  const changeTargetType = (type: RoadType) => {
    const arr = [...roadRegulationTypes]
    const idx = arr.indexOf(type)
    if (idx >= 0) {
      arr.splice(idx, 1)
    } else {
      arr.push(type)
    }
    setRoadRegulationTypes(arr)
  }

  const RoadStack = ({type, children}: React.PropsWithChildren< {type: RoadType } >) => {
    return (
      <Stack direction={'row'} alignItems={'center'}>
        <Checkbox size='small' sx={{p: 0, mr: 1}} checked={roadRegulationTypes.includes(type)} onChange={() => changeTargetType(type)} />
        {children}
      </Stack>
    )
  }

  const RoadStackColors = ({roadColors}: {roadColors: RoadColor[]}) => {
    return (
      <Stack>
        { roadColors.map((color, idx) => (
          <Stack key={idx} direction={'row'} alignItems={'center'}>
            <Paper sx={{width: 10, height: 10, backgroundColor: color.color, borderRadius: 0, mr: 1}} />
            <Typography mt={'2px'} fontSize={12} lineHeight={1.4}>{color.label}</Typography>
          </Stack>
        )) }
      </Stack>
    )
  }

  return (
    <>
      {showControl && (
        <Stack direction={'column'} width={150}>
          <Stack direction={'row'} alignItems={'center'} height={30}>
            <Checkbox size='small' sx={{p: 0, mr: 1}} checked={roadRegulation} onChange={() => setRoadRegulation(!roadRegulation)} />
            <Typography color={grey[700]} fontSize={11} fontWeight={'bold'}>道路規制情報</Typography>
          </Stack>
          { roadRegulation &&
          <>
            <Divider sx={{ my: '2px' }} />
            <RoadStack type={RoadType.TENKI}>
              <RoadStackColors roadColors={[roadColors.Jizen, roadColors.Saigai, roadColors.Kisyou]} />
            </RoadStack>
            <Divider sx={{ my: '2px' }} />
            <RoadStack type={RoadType.KOUJI}>
              <RoadStackColors roadColors={[roadColors.Kouji]} />
            </RoadStack>
            <Divider sx={{ my: '2px' }} />
            <RoadStack type={RoadType.YOKOKU}>
              <RoadStackColors roadColors={[roadColors.Yokoku]} />
            </RoadStack>
            <Divider sx={{ my: '2px' }} />
            <RoadStack type={RoadType.ETC}>
              <RoadStackColors roadColors={[roadColors.Etc, roadColors.Event]} />
            </RoadStack>
          </>
          }
        </Stack>
      )}
    </>
  )
}
